import React, { useState } from 'react'
import { ArrowBigUp, Repeat2, Rocket } from 'lucide-react'
import type { SignalType } from 'types/signals'
import type { PaidSignalConfirmTextItem } from './upvalueConfirmCopy'
import { paidSignalConfirmText } from './upvalueConfirmCopy'
import styles from 'components/votes/upvalueConfirmMessage.module.scss'

type UpvalueConfirmMessageProps = {
    signalType?: SignalType
    isSeed?: boolean
}

type UpvalueConfirmActionProps = {
    isSeed?: boolean
    onDontShowAgainChange?: (value: boolean) => void
}

export function UpvalueConfirmAction({ isSeed, onDontShowAgainChange }: UpvalueConfirmActionProps) {
    const [dontShowAgain, setDontShowAgain] = useState(true)

    const handleDontShowAgainChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const checked = ev.target.checked
        setDontShowAgain(checked)
        onDontShowAgainChange?.(checked)
    }

    return (
        <label className={styles.dontShow}>
            <input
                type="checkbox"
                data-testid={`${isSeed ? 'seed' : 'paid-upvalue'}-intro-dont-show-checkbox`}
                checked={dontShowAgain}
                onChange={handleDontShowAgainChange}
            />
            <span>Don&apos;t show this again</span>
        </label>
    )
}

function ConfirmRowIcon({ icon }: { icon: PaidSignalConfirmTextItem['icon'] }) {
    const iconProps = {
        size: 20,
        strokeWidth: 2,
        'aria-hidden': true,
    }

    if (icon === 'rocket') {
        return <Rocket {...iconProps} />
    }

    if (icon === 'repeat-2') {
        return <Repeat2 {...iconProps} />
    }

    return <ArrowBigUp {...iconProps} />
}

function ConfirmRowText({ item }: { item: PaidSignalConfirmTextItem }) {
    const highlightIndex = item.text.toLowerCase().indexOf(item.strongText.toLowerCase())

    if (highlightIndex < 0) {
        return <span>{item.text}</span>
    }

    const before = item.text.slice(0, highlightIndex)
    const highlightedText = item.text.slice(highlightIndex, highlightIndex + item.strongText.length)
    const after = item.text.slice(highlightIndex + item.strongText.length)

    return (
        <span>
            {before}
            <strong className={styles.highlight}>{highlightedText}</strong>
            {after}
        </span>
    )
}

export default function UpvalueConfirmMessage({ signalType, isSeed }: UpvalueConfirmMessageProps) {
    return (
        <div className={styles.comp}>
            {paidSignalConfirmText({ signalType, isSeed }).map(item => (
                <p key={item.text} className={styles.paragraph}>
                    <span className={styles.icon}>
                        <ConfirmRowIcon icon={item.icon} />
                    </span>
                    <ConfirmRowText item={item} />
                </p>
            ))}
        </div>
    )
}
